import React, { useState, useEffect } from "react";
import { omit } from "lodash";

import DashboardLayout from "../../dashboardDefaultLayout/DashboardLayout";
import Referral from "./Referral";
import ReferralCard from "./ReferralCard";
import Paycard from "./Paycard/Paycard";
import Referralcode from "./Referralcode";
import { $api } from "../../../../../helpers/$api";

const ReferralSection = () => {
  const [state, setState] = useState({
    membersReferred: 0,
    payouts: [],
    pendingEarnings: 0,
  });
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const {
          "Members Referred": membersReferred,
          Payouts: payouts,
          "Pending Earnings": pendingEarnings,
          referral_code,
        } = await $api.user.getReferralDashboardData();
        setState({ membersReferred, payouts, pendingEarnings, referral_code });
      } catch (error) {
        // ...
      } finally {
        setLoading(false);
      }
    })();
  }, [setState]);

  if (isLoading) {
    return null;
  }

  return (
    <DashboardLayout>
      <main>
        <div>
          <Referral pendingEarnings={state.pendingEarnings} />
          <ReferralCard data={omit(state, ["payouts"])} />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Paycard payouts={state.payouts} />
            <Referralcode referral_code={state.referral_code} />
          </div>
        </div>
      </main>
    </DashboardLayout>
  );
};

export default ReferralSection;
